import React from "react"

import {FieldFormElementViewProps} from "../../../../render/form-elemnent-view"
import SelectParentNew from "../../../../../gd-ui/select-parent-new/select-parent-new"
import FieldProject from "../project"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"

// const debug = 'FieldProject_FormElementView'
const debug = false

export default function FieldProject_FormElementView(props:FieldFormElementViewProps) {

    debug && console.log(debug, 'render', props)

    const disabled = _.get(props, 'disabled', false)

    const value = props.model[props.field.fieldId]

    const field: FieldProject = props.field as FieldProject

    return <SelectParentNew className               = {props.className}
                            projectId               = {value}
                            parentsFor              = {field.parentsFor}
                            placeholderIcon         = {props.field.noValueOptionIcon}
                            placeholder             = {field.placeholder}
                            unselectIcon            = {field.noValueOption ? props.field.noValueOptionIcon : undefined}
                            unselectLabel           = {field.noValueOption ? props.field.noValueOptionLabel : undefined}
                            displayWorkspaceRoot    = {field.displayWorkspaceRoot}
                            renderType              = {SelectParent_RenderType.FORM}
                            disabled                = {disabled}
                            onChange                = {(projectId:ID) => {if (props.onChange) props.onChange(projectId || null)}}/>

    /*return <SelectParent className          = {props.className}
                         renderValue        = "form" // "inline-editable" //"form"
                         parentsFor         = {field.parentsFor}
                         viewMode           = {field.viewMode}
                         placeholder        = {field.placeholder}
                         unselectLabel      = {field.noValueOption ? field.noValueOptionLabel : null}
                         companies          = {[gd.companyId]}
                         value              = {value ? {projectId: value} : null}
                         accessLevels       = {field.accessLevels}
                         showProjectIcon    = {true}
                         showIcon           = {true}
                         searchable         = {true}
                         disabled           = {disabled}
                         onChange           = {(data:any) => {if (props.onChange) props.onChange(data ? data.projectId : null)}}/>*/

    // return <FieldRenderEditableInlineInput viewClasses          = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", props.className)}
    //                                        field                = {props.field}
    //                                        value                = {value}
    //                                        disabled             = {disabled}
    //     // onChange             = {this.onChange}
    //                                        onImmediateChange    = {props.onChange}/>


}
